// Import style of the page.
import React, {Component, Fragment} from 'react'
import {Button} from "react-bootstrap";
import SVG from "react-inlinesvg";
import InformationTabs from "./full_profile/tabs/InformationTabs";
import PlayerBasicInformationCard from "../../ui/cards/PlayerBasicInformationCard";

import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {removeWatchlist} from "../../../store/actions/WatchlistActions";

import playerAvatar from "../../../assets/img/demo/player-avatar-7.png";
import deleteIcon from "../../../assets/svg/actions/icn-delete-blue.svg";

import "../../../assets/sass/pages/full-profile.scss";
import '../../../assets/sass/components/datatable/stats-and-videos-per-match-datatable.scss';
import Tools from "../../../Tools";

import {fullProfileQueries} from "../../../store/actions/Dashboard/FullProfile/FullProfileGraphQL";
import {gql, useQuery} from "@apollo/client";
import NoResultFound from "../../ui/feedback/NoResultFound";
import {setFullProfilePlayerId} from "../../../store/actions/Dashboard/FullProfile/FullProfileActions";
import Loading from "../../ui/feedback/Loading";
import NoError from "../../ui/feedback/NoError";

class FullProfile extends Component {

    constructor(props) {
        super(props);
        Tools.redirectToErrorPage(props, ['talent-search', 'watchlist', 'scouting']);
    }

    /**
     * Render full profile of player section.
     * @returns {React.ReactNode} The full profile section.
     */
    render = () => {

        return (
            <Fragment>
                {this.renderPageTitle()}
                <div className="d-flex justify-content-between">
                    {this.renderPlayerName()}
                    {this.renderDeleteWatchList()}
                </div>
                {this.renderProfileHeader()}
                {this.renderInformationTabs()}
            </Fragment>
        );
    };

    /**
     * Render title of page.
     * @returns {React.ReactNode} The page title div.
     */
    renderPageTitle = () => {
        const {pageTitle} = this.props;
        return (
            <div className="page-title">
                {pageTitle}
            </div>
        );
    };

    /**
     * Render player name.
     * @returns {React.ReactNode} The player name div.
     */
    renderPlayerName = () => {
        const {name: playerName} = this.props;
        return (
            <div className="player-name">
                {playerName}
            </div>
        );
    };

    renderDeleteWatchList = () => {
        return this.props.unique === 'watchlist' ? (
            <Button variant="link" className="delete-from-watchlist" onClick={this.handleRemoveFromWatchlistClick}>
                <span>Remove from Watchlist</span>
                <SVG src={deleteIcon}/>
            </Button>
        ) : null;
    };
    /**
     * Render profile header of player.
     * @returns {React.ReactNode} The player profile header.
     */
    renderProfileHeader = () => {
        const {player} = this.props;
        const {dob, marketValue, foot, position} = player;

        let items = [
            {title: "Goals Scored", value: "83"},
            {title: "Age", value: Tools.calculateAge(new Date(dob))},
            {title: "Market Value", value: Tools.formatterNumber(marketValue)},
            {title: "Foot", value: Tools.capitalize(foot)},
            {title: "Nationality", value: "Brazil"},
            {title: "Passport", value: "Brazil"},
            {title: "Curent Team", value: "Real Madrid"},
            {title: "Playing Position", value: position},
            {title: "Int. Matches", value: "18"},
            {title: "Int. Goals", value: "23"},
            {title: "Total Matches", value: "89"},
            {title: "Total Goals", value: "45"},
        ];

        return (
            <FullProfile.Header avatar={playerAvatar} items={items}/>
        );
    };

    /**
     * Render tabs that contains the rest of player information.
     * @returns {React.ReactNode} The player information tabs.
     */
    renderInformationTabs = () => {
        return (
            <FullProfile.InformationTabs/>
        );
    };

    /**
     * Handle click event of remove watchlist button.
     * @returns {void}
     */
    handleRemoveFromWatchlistClick = () => {
        this.props.removeWatchlist(this.props.full_profile_key)
    };

    static defaultProps = {
        // The title of the page shown in the top left corner.
        pageTitle: "Player Full Profile",
    };
}


FullProfile.Header = PlayerBasicInformationCard;
FullProfile.InformationTabs = InformationTabs;
FullProfile.Loading = props => <div className="w-100 h-100 d-flex justify-content-center align-items-center"><Loading text={"Loading..."} details={"Please wait. While we fetch the data"}/></div>;
FullProfile.Error = props => <div className="w-100 h-100 d-flex justify-content-center align-items-center"><NoError text={"Sorry, Something is broken"} details={"We unable to retrive data at this moment."}/></div>;

const FullProfileDataWrapper = props => {
    const playerId = props.match.params.id;

    const query = gql`
        query getPlayer ($playerId: String!) {
            player: player(id: $playerId){
                #Age
                dob
                #goalsScored
                careerStats{
                    goalsScored
                }
                #marketValue
                marketValue
                #foot
                foot
                #Nationality
                nationality{
                    name
                }
                #Passport
                passport{
                    name
                }
                #Current team
                team{
                    name
                }
                #positions
                position
                #Int. Matches
                #Int. Goals
                #Total Matches
                #Total Goals
                careerStats{
                    intMatchesPlayed
                    intGoalsScored
                    matchesPlayed
                }
            }
        }`;

    const {setPlayerId} = props;
    setPlayerId(playerId);

    const {loading, error, data} = useQuery(query, {
        variables: {
            playerId: playerId
        }
    });

    if (loading) {
        return <FullProfile.Loading/>;
    } else if (error) {
        return <FullProfile.Error/>;
    } else {
        const {player} = data;
        return <FullProfile player={player} {...props}/>;
    }
};


const mapStateToProps = (state) => {
    return {
        full_profile_key: state.full_profile.current.id,
        playerId: state.full_profile.playerId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        removeWatchlist: (key) => dispatch(removeWatchlist(key)),
        setPlayerId: (playerId) => dispatch(setFullProfilePlayerId(playerId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FullProfileDataWrapper));
